import { Building, MapPin, MapPinned, Building2, Search, Calendar, Box, User, FolderClosed, MessageSquareMore, GraduationCap, Hotel, LayoutDashboard, CircleDollarSign, CalendarDays, CalendarClock, ListChecks } from 'lucide-react';

var iconsMap = {
  LayoutDashboard: LayoutDashboard,
  Building: Building,
  MapPin: MapPin,
  MapPinned: MapPinned,
  Building2: Building2,
  Search: Search,
  Calendar: Calendar,
  Box: Box,
  User: User,
  FolderClosed: FolderClosed,
  MessageSquareMore: MessageSquareMore,
  GraduationCap: GraduationCap,
  Hotel: Hotel,
  CircleDollarSign: CircleDollarSign,
  CalendarDays: CalendarDays,
  CalendarClock: CalendarClock,
};

const menuItems = () => {
  const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
  const userType = (userProfile.userType || '').toUpperCase().trim();

  const userProfileMenu = userType === "SUPER_ADMIN"
    ? [
      { label: "User Profile", icon: User, to: "/user/profile/list" },
      { label: "Org", icon: Hotel, to: "/org/list" }
    ] : [
      { label: "User Profile", icon: User, to: "/userProfile/list" }
    ];

  return [
    {
      "label": "Dashboard",
      "icon": "LayoutDashboard",
      "to": "/dashboard"
    },
    {
      "label": "Organization Management",
      // icon: "",
      children: [
        {
          "label": "Safety Organization",
          "icon": Building2,
          "to": "/client/list"
        },
        {
          "label": "Region",
          "icon": MapPin,
          "to": "/region/list"
        },
        {
          "label": "Company Sites",
          "icon": MapPinned,
          "to": "/customer/list"
        },
        {
          "label": "Client Users",
          "icon": Building,
          "to": "/client/users/list"
        }
      ]
    },
    {
      "label": "Safety Sheet Operations",
      children: [
        {
          "label": "Sheets Search",
          "icon": Search,
          "to": "/formsubmission/list"
        },
        {
          "label": "Sheets Scheduler",
          "icon": Calendar,
          "to": "/scheduler"
        },
        {
          "label": "Sheets Dispatch",
          "icon": Box,
          "to": "/dispatches/list/0"
        },
        {
          "label": "Assignments",
          "icon": ListChecks,
          "to": "/assignments"
        }
      ]
    },
    {
      "label": "Compliance Management",
      children: [
        {
          "label": "Training & Certification",
          "icon": GraduationCap,
          "to": "/certificate/list"
        }
      ]
    },
    {
      "label": "Administration",
      children: [
        ...userProfileMenu,
        {
          "label": "Resources",
          "icon": FolderClosed,
          "to": "/resources/org/folder/list"
        },
        {
          "label": "Support Messages",
          "icon": MessageSquareMore,
          "to": "/support/messages/list"
        },
        {
          "label": "Payroll Sync",
          "icon": CircleDollarSign,
          "to": "/payrollsync/list"
        },
        {
          "label": "QuickBooks Sync Logs",
          "icon": CalendarDays,
          "to": "/batchdates/list"
        },
        {
          "label": "Payroll Mapping",
          "icon": CircleDollarSign,
          "to": "/payroll/mapping"
        },
        {
          "label": "Training Schedule",
          "icon": CalendarClock,
          "to": "/schedule"
        },
      ]
    }
  ]
}

export const getMenu = () => {
  const menu = menuItems().map(item => ({
    ...item,
    icon: iconsMap[item.icon]
  }));
  return [{ label: " ", content: menu }];
}
/* 

  {
    "label": "Users",
    "icon": "PeopleIcon",
    "to": "/user/list"
  },
*/
